import cx from 'classnames'
import { useState } from 'react'
import _ from 'lodash'

import styles from './DevicesFormList.module.scss'

import { FormControlLabel, ListItem, ListItemText, Collapse, Paper, List } from '@material-ui/core'
import Checkbox from '@mui/material/Checkbox'
import Radio from '@mui/material/Radio'
import { getMicaTypeLabel } from 'common/adapters/translations/getMicaTypeLabel'
import CollapseChevron from 'common/components/CollapseChevron/CollapseChevron'

const SelectableInput = ({ type, ...props }) => {
  const InputComponent = type === 'radio' ? Radio : Checkbox
  return (
    <InputComponent
      className={cx(styles.checkbox)}
      classes={{ checked: styles.checkedBox }}
      disableRipple
      {...props}
    />
  )
}

const DevicesFormList = ({
  systems,
  systemsGroupState,
  selectedDevices,
  checkAllDevicesIsClicked,
  isCheckAllDevices,
  inputType = 'checkbox',
  translate,
  handleSelectAllDevices,
  handleSelectAllGroupDevices,
  handleSelectDevice,
  register,
  disabledValidation
}) => {
  const [open, setOpen] = useState({})

  const isIndeterminateDevices = () => {
    return (
      checkAllDevicesIsClicked &&
      selectedDevices.length > 0 &&
      selectedDevices.length !== systems.length
    )
  }

  const handleClick = key => {
    const openKey = open[key]
    setOpen({ ...open, [key]: !openKey })
  }

  return (
    <div>
      {inputType === 'checkbox' && (
        <FormControlLabel
          className={styles.selectAllCheckboxForm}
          control={
            <Checkbox
              className={cx(styles.checkbox)}
              classes={{ checked: styles.checkedBox }}
              name='selectAllDevices'
              id='selectAllDevices'
              indeterminate={isIndeterminateDevices()}
              onChange={handleSelectAllDevices}
              checked={isCheckAllDevices}
            />
          }
          label={translate('downloadDataForm.selectAll')}
        />
      )}
      <Paper
        className={styles.devicesListPaper}
        classes={{ root: styles.paper }}
      >
        <List
          disableTouchRipple
          className={styles.devicesList}
        >
          {_.map(systemsGroupState, function (systems, group) {
            const systemsType = _.groupBy(systems, 'micaType')
            if (group === 'undefined') group = translate('noGroup')
            const isGroupExpanded = !open[group]
            return (
              <div
                className={styles.noGroupWrapper}
                key={group}
              >
                {group !== 'undefined' && (
                  <div>
                    <ListItem
                      button
                      disableTouchRipple
                      className={styles.groupListItem}
                    >
                      <span onClick={() => handleClick(group)}>
                        <CollapseChevron
                          expanded={isGroupExpanded}
                          className={styles.expandIcon}
                        />
                      </span>
                      {inputType === 'checkbox' && (
                        <Checkbox
                          className={cx(styles.checkbox)}
                          classes={{ checked: styles.checkedBox }}
                          name={group}
                          onChange={e => handleSelectAllGroupDevices(e, systems)}
                          id={group}
                        />
                      )}
                      <ListItemText
                        primary={group}
                        className={styles.listItemText}
                      />
                    </ListItem>
                  </div>
                )}

                {group !== 'undefined' && (
                  <Collapse
                    in={!open[group]}
                    timeout='auto'
                    unmountOnExit
                    classes={{
                      wrapper: styles.wrapper
                    }}
                  >
                    {_.map(systemsType, function (systems, type) {
                      const isTypeExpanded = !open[type]
                      return (
                        <div>
                          <ListItem
                            button
                            disableTouchRipple
                            className={styles.typeListItem}
                            key={group + '-' + type}
                          >
                            <span onClick={() => handleClick(type)}>
                              <CollapseChevron
                                expanded={isTypeExpanded}
                                className={styles.expandIcon}
                              />
                            </span>
                            <ListItemText
                              primary={getMicaTypeLabel(type, translate)}
                              className={styles.micaTypeItemText}
                            />
                          </ListItem>
                          <Collapse
                            in={!open[type]}
                            timeout='auto'
                            unmountOnExit
                          >
                            {systems.map((system, index) => {
                              return (
                                <div
                                  key={'system' + index}
                                  className={styles.micaItem}
                                >
                                  <FormControlLabel
                                    className={styles.checkboxForm}
                                    control={
                                      <SelectableInput
                                        type={inputType}
                                        checked={
                                          inputType === 'checkbox'
                                            ? selectedDevices.includes(system._id)
                                            : selectedDevices === system._id
                                        }
                                        onChange={handleSelectDevice}
                                        required
                                        outline='true'
                                        name='selectedDevices[]'
                                        inputRef={register}
                                        value={system._id}
                                        disabled={disabledValidation && disabledValidation(system)}
                                      />
                                    }
                                    label={system.name}
                                  />
                                </div>
                              )
                            })}
                          </Collapse>
                        </div>
                      )
                    })}
                  </Collapse>
                )}
              </div>
            )
          })}
        </List>
      </Paper>
    </div>
  )
}

export default DevicesFormList
